module.exports = "https://coursera_assets.s3.amazonaws.com/images/218b559f17ffe91b3340e1a34a7a6f4e.svg";